import { Immutable } from "immer";
import React from "react";
import { BlogTile } from "tsi-common-react/src/components/BlogTile/index";

import { templates } from "@reactivated";

type ICustomerContentHubBlogTileProps = Immutable<{
    tileImage?: {
        block: {
            url: string;
            title?: string | null;
        };
    } | null;
    tileTitle: string;
    tileBody: string;
    url: string;
    categories: templates.CustomerContentHubStoryPageDocumentTemplate["categories"];
    loveRootUrl: string;
}>;

export const CustomerContentHubBlogTile = (
    props: ICustomerContentHubBlogTileProps,
): React.JSX.Element => {
    return <BlogTile {...props} twitterHandle="sealy" />;
};
